module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-11.b7722599.svg";